import sentryBootstrap from "./sentry.bootstrap.js"
import sofeInspectorBootstrap from "./sofe-inspector.bootstrap.js"
import rootRouteBootstrap from "./root-route.bootstrap.js"

import { catchSyncStacktrace, syncStacktrace } from "auto-trace"

export default function bootstrapSpa() {
  const blockingPromises = [rootRouteBootstrap()]

  const nonBlockingPromises = [sentryBootstrap(Promise.resolve(window.loggedInUser)), sofeInspectorBootstrap()]

  Promise.all(nonBlockingPromises)
    .then(() => {
      console.info("The non-blocking bootstrap process for mobile-root-config has completed")
    })
    .catch(err => {
      nonBlockingPromises[0] // Make sure sentry is initialized
        .then(() => catchSyncStacktrace(err))
        .catch(() => catchSyncStacktrace(err)) // Sentry will be initialized even in an error caused by loggedInUser failing
    })

  return Promise.all(blockingPromises)
}
